import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  RecordBreakDto,
  TimeEntryBreakDto
} from '../../models/shifts/shift-breaks.dto';

@Injectable({
  providedIn: 'root'
})
export class ShiftsBreaksService {
  private readonly baseUrl = 'api/Shifts';
  private readonly contractorBaseUrl = 'api/Contractors/me/shifts';

  private readonly http = inject(HttpClient);

  create(
    shiftId: string,
    breakDuration: RecordBreakDto
  ): Observable<TimeEntryBreakDto> {
    return this.http.post<TimeEntryBreakDto>(
      `${this.baseUrl}/${shiftId}/breaks`,
      breakDuration
    );
  }

  update(
    shiftId: string,
    breakId: string,
    breakDuration: RecordBreakDto
  ): Observable<TimeEntryBreakDto> {
    return this.http.put<TimeEntryBreakDto>(
      `${this.baseUrl}/${shiftId}/breaks/${breakId}`,
      breakDuration
    );
  }

  get(shiftId: string): Observable<TimeEntryBreakDto[]> {
    return this.http.get<TimeEntryBreakDto[]>(
      `${this.baseUrl}/${shiftId}/breaks`
    );
  }

  delete(shiftId: string, breakId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${shiftId}/breaks/${breakId}`
    );
  }

  // ── Contractor-owned endpoints (/api/Contractors/me/shifts/{shiftId}/breaks) ──

  getContractorBreaks(shiftId: string): Observable<TimeEntryBreakDto[]> {
    return this.http.get<TimeEntryBreakDto[]>(
      `${this.contractorBaseUrl}/${shiftId}/breaks`
    );
  }

  createContractorBreak(
    shiftId: string,
    body: Partial<RecordBreakDto>
  ): Observable<TimeEntryBreakDto> {
    return this.http.post<TimeEntryBreakDto>(
      `${this.contractorBaseUrl}/${shiftId}/breaks`,
      body
    );
  }

  updateContractorBreak(
    shiftId: string,
    breakId: string,
    body: Partial<RecordBreakDto>
  ): Observable<TimeEntryBreakDto> {
    return this.http.put<TimeEntryBreakDto>(
      `${this.contractorBaseUrl}/${shiftId}/breaks/${breakId}`,
      body
    );
  }
}
